<template>
<!--<div class="text-center">
    <div class="animate__animated animate__fadeInDown">
        <img src="/storage/images/logo-icon.svg" class="form-icon" />
    </div>
</div>-->
</template>

<style scoped>
</style>

<script>
export default {
    mounted() {

    },
    data() {
        return {

        }
    },
    components: {},
    props: [],
}
</script>
